export default "__VITE_ASSET__8omyGpD5__"